export enum MatchingRelationType {
  Matched = "matched",
  Available = "available",
  Prefiltered = "prefiltered",
  PrefilteredAndAvailable = "prefiltered_and_available"
}
